import { Component } from '@angular/core';
import { SecurityService } from '@services/security.service';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { AsyncPipe } from '@angular/common';
import { GlobalAdministrationUsersComponent } from './user/user.component';
import { MatCard } from '@angular/material/card';
import { GlobalAuthorityRequestsComponent } from './global-authority-requests/global-authority-requests.component';
import { GlobalAuthority } from '@app/shared/models/global-authority';

@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.scss'],
  imports: [
    MatTabGroup,
    MatTab,
    GlobalAdministrationUsersComponent,
    MatCard,
    GlobalAuthorityRequestsComponent,
    AsyncPipe
  ]
})
export class UserInformationComponent {
  constructor(private readonly securityService: SecurityService) {}
  private permissionStored: { [authority: string]: Observable<boolean> } = {};

  protected readonly GlobalAuthority = GlobalAuthority;

  public checkPermission(authority: GlobalAuthority): Observable<boolean> {
    if (!this.permissionStored[authority.toString()]) {
      this.permissionStored[authority.toString()] = this.securityService.isAuthorized(authority).pipe(shareReplay(1));
    }
    return this.permissionStored[authority.toString()];
  }
}
